import {Component, ElementRef, EventEmitter, Input, OnDestroy, Output, NgZone, OnInit} from '@angular/core';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-high-chart-casino',
  template: ''
})
export class HighChartCasinoComponent implements OnDestroy {

  @Input() Highcharts: typeof Highcharts | any;
  @Input() constructorType: string | any;
  @Input() callbackFunction: Highcharts.ChartCallbackFunction | any;
  @Input() oneToOne: boolean | any;
  @Input() runOutsideAngular: boolean | any;

  @Input() set options(val: Highcharts.Options) {
    if (!val) return;
    this.optionsValue = val;
    this.recreateChart(this.optionsValue);
  }

  @Input() set update(val: boolean) {
    if (val && this.optionsValue) {   // <-- only call if optionsValue exists
      this.recreateChart(this.optionsValue);
      this.updateChange.emit(false);
    }
  }

  @Output() updateChange = new EventEmitter<boolean>(true);
  @Output() chartInstance  = new EventEmitter<Highcharts.Chart>();

  private chart: Highcharts.Chart | any;
  private optionsValue: Highcharts.Options | undefined;

  constructor(
    private el: ElementRef,
    private _zone: NgZone
  ) {}

  /**
   * Recreates the chart from scratch.
   * This ensures old series do not remain in the chart.
   */
  public recreateChart(newOptions: Highcharts.Options) {
    if (!newOptions) return;

    // Destroy old chart if exists
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }

    const create = () => {
      const optionsCopy = {
        ...newOptions,
        series: newOptions.series ? [...newOptions.series] : []
      };

      this.chart = (this.Highcharts as any)[this.constructorType || 'chart'](
        this.el.nativeElement,
        optionsCopy,
        this.callbackFunction || null
      );

      this.chartInstance.emit(this.chart);
    };

    if (this.runOutsideAngular) {
      this._zone.runOutsideAngular(() => create());
    } else {
      create();
    }
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}